import { AppState } from 'src/app/store'

export const currencyListSelector = (state: AppState) => state.currencies.list.data
export const loadingCurrenciesSelector = (state: AppState) => state.currencies.list.loading
